// src/components/directorProfile/DirectorProfileWizard.jsx
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { WIZARD_STEPS_AGENCY_PROFILE } from '../../../utils/agencyProfileConstants';
import './DirectorProfileWizard.css';

const DirectorProfileWizard = ({ currentStep, onStepClick }) => {
    const totalSteps = WIZARD_STEPS_AGENCY_PROFILE.length;
    const progressPercent = totalSteps > 1 ? (currentStep / (totalSteps - 1)) * 100 : 0;

    return (
        <div 
            className="wizard-container director-profile-wizard"
            style={{ '--total-steps': totalSteps }}
        >
            <div className="step-indicator-wrapper">
                <div className="step-progress-track">
                    <div 
                        className="step-progress-fill" 
                        style={{ width: `${progressPercent}%` }}
                    ></div>
                </div>
                {WIZARD_STEPS_AGENCY_PROFILE.map((step, index) => (
                    <div 
                        key={step.id} 
                        className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                        onClick={() => onStepClick && onStepClick(index)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                        <div className="step-label">{step.title}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DirectorProfileWizard;